import { render } from "./SettingsCreditCardFee.vue?vue&type=template&id=5447aad3"
import script from "./SettingsCreditCardFee.vue?vue&type=script&lang=js"
export * from "./SettingsCreditCardFee.vue?vue&type=script&lang=js"

import "./SettingsCreditCardFee.vue?vue&type=style&index=0&id=5447aad3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__